import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SEOHead from "@/components/SEOHead";

interface LayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
  path: string;
  image?: string;
  type?: "website" | "article";
  publishedTime?: string;
  modifiedTime?: string;
  noindex?: boolean;
}

const Layout = ({
  children,
  title,
  description,
  path,
  image,
  type = "website",
  publishedTime,
  modifiedTime,
  noindex = false,
}: LayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <SEOHead
        title={title}
        description={description}
        path={path}
        image={image}
        type={type}
        publishedTime={publishedTime}
        modifiedTime={modifiedTime}
        noindex={noindex}
      />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
